import React, { useEffect, useState } from 'react';
import CarouselComponent from '../sharedCarousel/CarouselComponent';
import { viewport } from '../../utils/utils';
import { LineTableBasicPropConfig } from '../../services';
import {
  fetchOfferingDataV2,
  getDeviceDetails,
  getDeviceModelsList
} from '../../services/LineTableService';
import { getDeviceWithVarients } from './DpTableUtils';
import DpProduct from './DpProduct';

const DpTabContainer = ({ tabData, tabIndex, mainContent, activeTab, metadata, isProdEnv }: any) => {
  const [offeringData, setOfferingData] = useState<any[]>([]); //offerAPI response
  const [devicesVarientList, setDevicesVarientList] = useState<any>(); //Holds the detail list of selected device like memory and color ex: Black-256GB
  const [deviceModelsList, setDeviceModelsList] = useState([]); //Holds the list of device models which is displayed in dropdown
  const endPoint = LineTableBasicPropConfig?.getInstance()?.getBaseUrl();
  const viewPort = viewport();

  //To make only 3 items visible even in large desktop view
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 10000, min: 1440 },
      items: 3
    }
  };

  //creating reuestBody for offer API call
  const offerRequestBody = tabData?.items?.map((rateplan: any) => {
    if (rateplan?.mobProductId) {
      return {
        id: rateplan?.mobProductId,
        promoIds: [rateplan?.mobPromoId]
      };
    }
  });

  useEffect(() => {
    if (
      offeringData?.length === 0 &&
      offerRequestBody?.length > 0 &&
      mainContent?.tabContainer?.[activeTab]?.brand === tabData?.brand
    ) {
      // Making the offerAPI call
      fetchOfferingDataV2(offerRequestBody, endPoint, true)
        .then((data: any) => {
          if (data && Object.keys(data)?.length > 0) {
            setOfferingData(data);
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log('error--->', error);
        });
    }

    if (
      mainContent?.tabContainer?.[activeTab]?.defaultDevice &&
      mainContent?.tabContainer?.[activeTab]?.brand === tabData?.brand
    ) {
      //API call to get the device price and varient details from the default device name we get from SB
      fetchDeviceDetails(mainContent?.tabContainer?.[activeTab]?.defaultDevice);
    }

    if (
      mainContent?.tabContainer?.[activeTab]?.brand &&
      mainContent?.tabContainer?.[activeTab]?.brand === tabData?.brand
    ) {
      //API call to get the list of devices which needs to be displayed in dropdown
      fetchDeviceModelsList(mainContent?.tabContainer?.[activeTab]?.brand);
    }
  }, [activeTab]);

  //API call to get the device price and varient details from the default device name we get from SB
  const fetchDeviceDetails = (deviceID: string | any) => {
    if (!devicesVarientList?.[deviceID]) {
      getDeviceDetails(deviceID, endPoint)
        .then((res: any) => {
          const deviceWithVarients = getDeviceWithVarients(res) ?? false;
          if (deviceWithVarients && Object?.keys(deviceWithVarients)?.length > 0) {
            setDevicesVarientList({ ...devicesVarientList, [`${deviceID}`]: deviceWithVarients });
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log('error--->', error);
        });
    }
  };

  //API call to get the list of devices which needs to be displayed in dropdown
  const fetchDeviceModelsList = (brandId: string) => {
    if (deviceModelsList?.length === 0 && brandId) {
      getDeviceModelsList(brandId, endPoint)
        .then((res: any) => {
          if (res?.hardwares?.length > 0) {
            setDeviceModelsList(res?.hardwares);
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log('error--->', error);
        });
    }
  };

  return (
    //added the classname as linetableV3 to add the padding for the linetable which is handeled in main repos
    <div className='linetableV3'>
      {viewPort && tabData?.items?.length > 0 && (
        //mapping the products in each tab
        <CarouselComponent carouselIndex={0} key={tabIndex} arrow={true} responsive={responsive}>
          {(tabData?.items || [])?.map((product: any, index: number) => {
            return (
              <div key={index}>
                <DpProduct
                  productData={product} //individual items data
                  mainContent={mainContent} //whole content
                  tabIndex={tabIndex} //present tab indx
                  indexKey={index} //product index
                  cardsLength={tabData?.items?.length} //total no of products in the tab
                  offerDataList={offeringData} //offerAPI
                  activeTab={activeTab} //active tab index
                  deviceModelsList={deviceModelsList} //device models list for dropdown
                  deviceDetailsList={devicesVarientList} //device hardware details like memory, color and price
                  fetchDeviceDetails={fetchDeviceDetails} //call back to trigger hardwares API call when device model is changed
                  metadata={metadata}
                  isProdEnv={isProdEnv}
                />
              </div>
            );
          })}
        </CarouselComponent>
      )}
    </div>
  );
};

export default DpTabContainer;
